/*globals EB*/
function Messaging() {
	this.listenerList = {};
	this.init();
}

Messaging.prototype.init = function() {
	console.log('[Messaging] init');
	var _this = this;
	window.addEventListener('message', function(event) {
		try {
			var messageData = JSON.parse(event.data);
			_this.messageReceived(messageData);
		} catch (e) {
			console.error('message ignoré : ', event);
		}
	});
};

Messaging.prototype.dispatchMessage = function(type, data) {
	if (!data) data = {};
	if (!data.uid && EB._adConfig) data.uid = EB._adConfig.uid;
	if (type !== 'moveEvent') console.log('  [dispatch msg] ', type, data);

	EB._sendMessage(type, data);
};

Messaging.prototype.messageReceived = function(messageData) {

	if (messageData.type !== 'moveEvent') console.log('  [receive msg] ', messageData.type, messageData.data);

	/*if (messageData.type === 'SCREEN_ORIENTATION') alert('SCREEN_ORIENTATION ' + messageData.data + ' ' + messageData.data.uid);

	if (messageData.type === 'ORIENTATION_CHANGE') {

		for (var prop in messageData.data) {
			alert('* ' + messageData.data[prop]);
		}

	} */

	if (messageData.type === 'PUSHDOWN_TRANSITION_END') console.log('[PUSHDOWN_TRANSITION_END] received !');

	if (messageData.data && (EB._isLocalMode || messageData.data.uid === EB._adConfig.uid)) {
		var list = this.listenerList[messageData.type];
		if (list) {
			for (var i = 0; i < list.length; i++) {
				list[i](messageData.data);
			}
		}
	}
};

Messaging.prototype.addMessageListener = function(typeMessage, funcToCall) {

	if (!this.listenerList[typeMessage]) {
		this.listenerList[typeMessage] = [];
	}

	this.listenerList[typeMessage].push(funcToCall);
};

module.exports = Messaging;
